import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import asyncDataByUuid from "../../store/thunks/accounting/asyncDataByUuid";
import { useParams } from "react-router-dom";
import { setYear } from "../../store/slices/accountingSlice";

import './Accounting.scss';

const months = {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь',
}

export default function Accounting() {
    const year = useSelector(state => state.accounting.year);
    const user = useSelector(state => state.accounting.name);
    const paychecks = useSelector(state => state.accounting.paychecks);
    const message = useSelector(state => state.accounting.message);
    const dispatch = useDispatch();
    const {uuid} = useParams();

    useEffect(() => {
        dispatch(asyncDataByUuid({uuid, year}));
    }, [year]);

    const handleYear = ({target}) => {
        dispatch(setYear(target.value));
    }
    
    return (
        <main className="accounting-page">
            <div className="_container">
                <select className="accounting-page__select" value={year} onChange={handleYear}>
                    <option value={2022}>2022</option>
                    <option value={2021}>2021</option>
                    <option value={2020}>2020</option>
                    <option value={2019}>2019</option>
                    <option value={2018}>2018</option>
                    <option value={2017}>2017</option>
                    <option value={2016}>2016</option>
                    <option value={2015}>2015</option>
                    <option value={2014}>2014</option>
                    <option value={2013}>2013</option>
                    <option value={2012}>2012</option>
                </select>
                <div className="employee-title">
                    <h3 className="bold">Сотрудник:</h3>
                    <p>{user}</p>
                </div>
                <ul className="accounting__list">
                    <li className="accounting__message">{message}</li>
                    { paychecks.length > 0 &&
                        paychecks.map(({month, isViewed, viewedAt}, idx) => {
                            return <li 
                                className="accounting__list__item" 
                                key={idx}>
                                <span className="month">{months[month]}</span>
                                <span className="is-viewed">{!isViewed ? "Не Просмотрено" : "Просмотрено"}</span> 
                                <span className="viewed-at" title={!viewedAt ? "Документ не просмотрен": "Время просмотра"}>{!viewedAt ? "-" : viewedAt}</span>
                            </li>
                        })
                    }
                </ul>
            </div>
        </main>
    )
}